
import { Component, Vue } from "vue-property-decorator";
import Login from "../components/Login.vue";
import PasswordChangeDialog from "../components/Base/PasswordChangeDialog.vue";

@Component({
  components: {
    Login,
    PasswordChangeDialog,
  },
})
class Home extends Vue {
  get showPasswordDialog(): boolean {
    return this.$store.state.authenication.passwordDialog;
  }
}

export default Home;
